import { ModalPopup } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useAppSelector } from '../../../appStore';
import Constants from '../../../constants';
import ContentConstants from '../../../contentConstants';
import { SurveyPreviewSvg } from './SurveyPreviewSvg';

export const SurveyPreviewModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	const { surveyTheme } = useAppSelector((state) => state.surveyTheme);
	const { themes } = useAppSelector((state) => state.themes);
	const { progressMeterType, shouldShowQuestionNumbering: showQuestionNumbering } = useAppSelector(
		(state) => state.survey.surveyEditModel.survey,
	);

	return (
		<ModalPopup
			isOpen={isOpen}
			title={ContentConstants.BRANDING_AND_THEME.SURVEY_PREVIEW_MODAL.TITLE}
			hideFooter={true}
			contenthcentered={true}
			contentvcentered={true}
			contentfullwidth={true}
			onClosed={onClose}
		>
			<SurveyPreviewSvg
				theme={surveyTheme ?? themes[Constants.DEFAULT_THEME_NAME]}
				progressMeterType={progressMeterType}
				showQuestionNumbering={showQuestionNumbering}
			/>
		</ModalPopup>
	);
};
